export const STRIPE_ORDER_DETAILS_PATH = "/stripe/order/:orderId";

export function toStripeOrderDetailsPath(orderId: string): string {
  return STRIPE_ORDER_DETAILS_PATH.replace(
    ":orderId",
    encodeURIComponent(orderId),
  );
}
